<div class="map-container hidden-print" [class.rounded]="rounded">
  <div #mapElement></div>
</div>